var _mask, _path, _path2, _mask2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThunderstorm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 112,
    height: 68,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 4,
    width: 112,
    height: 68
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6001 28C39.3797 14.3066 51.4863 4 66 4C80.533 4 92.6524 14.3339 95.4109 28.0545C104.693 28.7741 112 36.5337 112 46C112 55.9411 103.941 64 94 64H26C16.0589 64 8 55.9411 8 46C8 36.0589 16.0589 28 26 28H36.6001Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6001 28C39.3797 14.3066 51.4863 4 66 4C80.533 4 92.6524 14.3339 95.4109 28.0545C104.693 28.7741 112 36.5337 112 46C112 55.9411 103.941 64 94 64H26C16.0589 64 8 55.9411 8 46C8 36.0589 16.0589 28 26 28H36.6001Z",
    fill: "#AAAAAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6001 28C39.3797 14.3066 51.4863 4 66 4C80.533 4 92.6524 14.3339 95.4109 28.0545C104.693 28.7741 112 36.5337 112 46C112 55.9411 103.941 64 94 64H26C16.0589 64 8 55.9411 8 46C8 36.0589 16.0589 28 26 28H36.6001Z",
    stroke: "white",
    strokeWidth: 8,
    mask: "url(#path-2-outside-1)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-2",
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 35,
    width: 52,
    height: 79,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 31,
    y: 35,
    width: 52,
    height: 79
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2175 40.1729C70.3313 41.9498 70.6043 45.1038 68.8273 47.2176L50.7355 68.7382L74.0001 68.7382C75.8655 68.7382 77.5758 69.7767 78.4363 71.4318C79.2968 73.0869 79.1644 75.0834 78.0928 76.6103L56.5056 107.372C54.9193 109.633 51.801 110.179 49.5406 108.593C47.2803 107.007 46.7337 103.888 48.32 101.628L64.383 78.7382L40.0001 78.7382C38.0561 78.7382 36.2883 77.6114 35.4676 75.8492C34.6468 74.087 34.9219 72.0088 36.1728 70.5207L61.1728 40.7826C62.9498 38.6689 66.1038 38.3959 68.2175 40.1729Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2175 40.1729C70.3313 41.9498 70.6043 45.1038 68.8273 47.2176L50.7355 68.7382L74.0001 68.7382C75.8655 68.7382 77.5758 69.7767 78.4363 71.4318C79.2968 73.0869 79.1644 75.0834 78.0928 76.6103L56.5056 107.372C54.9193 109.633 51.801 110.179 49.5406 108.593C47.2803 107.007 46.7337 103.888 48.32 101.628L64.383 78.7382L40.0001 78.7382C38.0561 78.7382 36.2883 77.6114 35.4676 75.8492C34.6468 74.087 34.9219 72.0088 36.1728 70.5207L61.1728 40.7826C62.9498 38.6689 66.1038 38.3959 68.2175 40.1729Z",
    fill: "#F7DB53"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2175 40.1729C70.3313 41.9498 70.6043 45.1038 68.8273 47.2176L50.7355 68.7382L74.0001 68.7382C75.8655 68.7382 77.5758 69.7767 78.4363 71.4318C79.2968 73.0869 79.1644 75.0834 78.0928 76.6103L56.5056 107.372C54.9193 109.633 51.801 110.179 49.5406 108.593C47.2803 107.007 46.7337 103.888 48.32 101.628L64.383 78.7382L40.0001 78.7382C38.0561 78.7382 36.2883 77.6114 35.4676 75.8492C34.6468 74.087 34.9219 72.0088 36.1728 70.5207L61.1728 40.7826C62.9498 38.6689 66.1038 38.3959 68.2175 40.1729Z",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#path-3-outside-2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderstorm);
export default __webpack_public_path__ + "static/media/thunderstorm.14990996a4ac5f96eb75fb50ccb5e16d.svg";
export { ForwardRef as ReactComponent };